
    export enum EnumSubmissionType {
			IngredientAdd = 0,
			IngredientModifyRmc = 1,
			IngredientDelete = 2,
			ProductAdd = 3,
			ProductCopy = 4,
			ProductTerminate = 5,
    }